import { render, staticRenderFns } from "./NewFeedback.vue?vue&type=template&id=25d4051c"
import script from "./NewFeedback.vue?vue&type=script&lang=js"
export * from "./NewFeedback.vue?vue&type=script&lang=js"
import style0 from "./NewFeedback.vue?vue&type=style&index=0&id=25d4051c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports